const devConsoleFontStyles = 'font-size: 14px; font-weight: bold;';
const devConsoleStyleLookup = {
  error: `${devConsoleFontStyles}`,
  info: `${devConsoleFontStyles} color: #4461D7`,
  success: `${devConsoleFontStyles} color: green`,
  warning: `${devConsoleFontStyles}`,
};

const getFormattedMessages = (originalMessages, formatting) => {
  const addFormattingToText = (formattedMessages, message) => {
    if (typeof message === 'string') {
      return [...formattedMessages, `%c${message}`, formatting];
    }
    return [...formattedMessages, message];
  };
  return originalMessages.reduce(addFormattingToText, []);
};

const devLogger = {
  logError(...args) {
    // call sentry
    console.error(...args);
  },
  logInfo(...args) {
    console.info(...getFormattedMessages(args, devConsoleStyleLookup.info));
  },
  logDebug(message) {
    console.debug(`%c${message}`, 'color:red;font-size: 14px; font-weight: bold;');
  },
  logObject(...args) {
    console.dir(...args);
  },
  logStatus(key, value) {
    if (value) {
      console.info(...getFormattedMessages([key], devConsoleStyleLookup.info), '✅');
    }
  },
};

const productionLogger = {
  logError() {} /* @TODO hit sentry */,
  logInfo() {} /* no-op */,
  logDebug() {} /* no-op */,
  logObject() {} /* no-op */,
  logStatus() {} /* no-op */,
};

export default function useLogger() {
  // switch between loggers in different environments
  const logger = process.env.NODE_ENV === 'production' ? productionLogger : devLogger;

  return logger;
}
